import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/index.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Overzicht',
      meta: { layout: 'default' },
      component: home
    }
  ]
})
